'use client';
import { PropsWithChildren, useEffect, useState } from 'react';

import env from 'config/env';

import initDatadog from './datadog';
import { injectScript } from './miscellaneous';

const AppInit = () => {
  // Initialise datadog
  useEffect(() => {
    initDatadog(env.DATADOG);
  }, []);

  // Inject app switcher script
  useEffect(() => {
    if (!env.ENV) {
      return;
    }
    // Increment this version every time there is a change to the appswitcher.js file (to bust cache).
    const VERSION = '1';

    let appSwitcherBaseUrl = 'https://cdn.dev.ef.studio';
    if (env.ENV === 'prod') {
      appSwitcherBaseUrl = 'https://cdn.ef.studio';
    }

    injectScript(`${appSwitcherBaseUrl}/appswitcher/appswitcher.js?v=${VERSION}`);
  }, []);

  return null;
};

const isMockMode = env.MOCKED;
let mockingReady: Promise<void> | null = null;
const getMockingReady = () => {
  if (!mockingReady) {
    mockingReady = import('network/mocks/browser').then(({ enableMocking }) => enableMocking());
  }
  return mockingReady;
};

export const MswReadyGate = ({ children }: PropsWithChildren) => {
  const [ready, setReady] = useState(!isMockMode);

  useEffect(() => {
    if (isMockMode) {
      getMockingReady().then(() => setReady(true));
    }
  }, []);

  if (!ready) {
    return null;
  }

  return children;
};

export default AppInit;
